/** @format */

import React, { useContext } from "react";
import {
  Grid,
  Typography,
  makeStyles,
  CssBaseline,
  Card,
  CardContent,
  Divider,
  Tooltip,
  Fab,
  Button,
  Modal,
  Backdrop,
  Fade,
  TableContainer,
  Table,
  TableCell,
  TableRow,
  TableBody,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";
//import FondoImagenes from '/static/imagen/fondo.jpg';
//Icononos  asignados
import HomeWorkOutlinedIcon from "@material-ui/icons/HomeWorkOutlined";
import CommuteOutlinedIcon from "@material-ui/icons/CommuteOutlined";
import AccountBalanceWalletOutlinedIcon from "@material-ui/icons/AccountBalanceWalletOutlined";
import BallotOutlinedIcon from "@material-ui/icons/BallotOutlined";
import CardTravelOutlinedIcon from "@material-ui/icons/CardTravelOutlined";
import ImportExportOutlinedIcon from "@material-ui/icons/ImportExportOutlined";
import TrendingDownOutlinedIcon from "@material-ui/icons/TrendingDownOutlined";
import DomainOutlinedIcon from "@material-ui/icons/DomainOutlined";
import ImportContactsOutlinedIcon from "@material-ui/icons/ImportContactsOutlined";

import TblAcreditacion from "./TblAcreditacion";
import { TblOrdenesnoPago } from "./TblOrdenesnoPago";
import TblSociedades from "./TblSociedades";
import TblProtestos from "./TblProtestos";
import TblMorosidad from "./TblMorosidad";

import UserContext from "../../context/Globales/UserContext";
import TblPropiedades from "./TblPropiedades";
import { TblBoletinLabo } from "./TblBoletinLabo";
import { TblDetalleVehiculo } from "./TblDetalleVehiculo";

const useStyles = makeStyles((theme) => ({
  tituloTable: {
    backgroundColor: "#e6e6e6",
    minWidth: 200,
    color: "black",
    textAlign: "center",
    padding: "16px",
    fontWeight: "250",
    fontSize: "16px",
  },
  TituloIdentificacion: {
    backgroundColor: theme.palette.primary.main,
    backgroundImage: `url(${
      process.env.PUBLIC_URL + "/static/imagen/fondo.jpg"
    })`,
    minWidth: 200,
    color: "black",
    textAlign: "left",
    padding: "15px",
    fontWeight: "450",
    fontSize: "18px",
    height: "auto",
    alignContent: "center",
  },

  buttonVermas: {
    color: "white",

    "&:hover": {
      width: "100%",
      backgroundColor: "#1976d2",
      color: "white",
    },
  },

  fondoCardIndicadores: {
    backgroundColor: theme.palette.fondotitulos.main,
    color: "#171717",
    textAlign: "center",
    margin: "10px",
    padding: "15px",
    fontWeight: "300",
    fontSize: "14px",
    height: "145px",

    "&:hover": {
      backgroundColor: "#bbdefb",
      color: "#171717",
      textTransform: "uppercase",
      padding: "15px",
      fontWeight: "bold",
      height: "auto",
    },
  },

  FondoTable: {
    backgroundColor: theme.palette.greyFondo.main,
  },
  indicadores: {
    padding: "60px",
    alignContent: "center",
  },
  buttonSuccess: {
    backgroundColor: "#04ba65",
    color: "white",
    size: "15px",
    "&:hover": {
      backgroundColor: "#02bf67",
      color: "white",
    },
  },

  ButtonDanger: {
    backgroundColor: theme.palette.secondary.main,
    color: "white",
    "&:hover": {
      backgroundColor: "#a1122e",
      color: "white",
    },
  },
  buttonGray: {
    backgroundColor: "#cfcaca",
    color: "white",
    "&:hover": {
      backgroundColor: "#dedcdc",
      color: "white",
    },
  },

  sizeIcono: {
    height: "38px",
    width: "38px",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    overflow: "scroll",
    height: "100%",
  },

  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "70%",
    height: "90%",
    overflow: "scroll",
  },

  // FondoTable: { backgroundColor: theme.palette.greyFondo.main },

  mousePointer: { cursor: "pointer" },
}));

const IndicadoresPositivoNegativo = () => {
  const classes = useStyles();
  const {
    datoIC,
    DatodetalleVehiculos,
    DatodetalleBoletin,
    DatoListaSA,
    DatodetallePropBienes,
  } = useContext(UserContext);
  const [DatoBAnco] = React.useState(
    datoIC && datoIC.DetalleInformacionPositiva?.MovimientosDeBancos
  );

  const userContext = useContext(UserContext);

  const [OpenModalAcreditacion, setOpenModalAcreditacion] =
    React.useState(false);
  const [OpenModalSociedades, setOpenModalSociedades] = React.useState(false); //
  const [OpenMOdalProtestos, setOpenMOdalProtesto] = React.useState(false);
  const [OpenMOdalMorosidad, setOpenModalMorosidad] = React.useState(false);
  const [OpenModalPropiedades, setOpenModalPropiedades] = React.useState(false);
  const [OpenModalBoletin, setOpenModalBoletin] = React.useState(false);

  const [OpenModalVehiculo, setOpenModalVehiculo] = React.useState(false);

  const handleClickVehiculo = () => {
    if (DatodetalleVehiculos == null) {
      setOpenModalVehiculo(true);
      userContext.getDetalleVehiculo(
        datoIC.Identificacion?.Rut.replace(/[.]/g, ""),
        datoIC.ID
      );
    } else {
      setOpenModalVehiculo(true);
    }
  };

  const handleClickVehiculoCerrar = () => {
    setOpenModalVehiculo(false);
  };

  const handleClickBoletin = () => {
    if (DatodetalleBoletin == null || DatodetalleBoletin == "ERROR CONSULTA") {
      setOpenModalBoletin(true);
      userContext.getDetalleBoletin(
        datoIC.Identificacion?.Rut.replace(/[.]/g, ""),
        datoIC.ID
      );
    } else {
      setOpenModalBoletin(true);
    }
  };

  const handleClickBoletinCerrar = () => {
    setOpenModalBoletin(false);
  };
  const hanleClickOpenMorosidad = () => {
    setOpenModalMorosidad(!OpenMOdalMorosidad);
  };

  const hanleClickOpenProtesto = () => {
    setOpenMOdalProtesto(!OpenMOdalProtestos);
  };

  const hanleClickOpenSociedades = () => {
    if (DatoListaSA == null || DatoListaSA == "ERROR CONSULTA ASOCIADOS") {
      setOpenModalSociedades(true);
      userContext.getLitadeSociosAsociados(
        datoIC.Identificacion?.Rut.replace(/[.]/g, ""),
        datoIC.ID
      );
    } else {
      setOpenModalSociedades(true);
    }
  };

  const hanleClickOpenSociedadesCerrar = () => {
    setOpenModalSociedades(false);
  };

  const handleClickOpenAcreditacion = () => {
    setOpenModalAcreditacion(!OpenModalAcreditacion);
  };

  const handleClickOpenPropiedades = () => {
    if (
      DatodetallePropBienes == null ||
      DatodetallePropBienes == "ERROR CONSULTA PROPIEDADES"
    ) {
      setOpenModalPropiedades(true);
      userContext.getDetallePropBienes(
        datoIC.Identificacion?.Rut.replace(/[.]/g, ""),
        datoIC.ID
      );
    } else {
      setOpenModalPropiedades(true);
    }
  };
  const handleClickOpenPropiedadesCerrar = () => {
    setOpenModalPropiedades(false);
  };
  return (
    <div>
      {/** Vehiculos */}
      <CssBaseline />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={OpenModalVehiculo}
        onClose={handleClickVehiculoCerrar}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={OpenModalVehiculo}>
          <div className={classes.paper}>
            <Typography
              variant="h5"
              align="right"
              onClick={handleClickVehiculoCerrar}
              className={classes.mousePointer}
            >
              X
            </Typography>

            <TblDetalleVehiculo />
          </div>
        </Fade>
      </Modal>

      {/** Boletin Laboral */}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={OpenModalBoletin}
        onClose={handleClickBoletinCerrar}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={OpenModalBoletin}>
          <div className={classes.paper}>
            <Typography
              variant="h5"
              align="right"
              onClick={handleClickBoletinCerrar}
              className={classes.mousePointer}
            >
              X
            </Typography>

            <TblBoletinLabo />
          </div>
        </Fade>
      </Modal>

      {/** Propiedades y bienes */}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={OpenModalPropiedades}
        onClose={handleClickOpenPropiedadesCerrar}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={OpenModalPropiedades}>
          <div className={classes.paper}>
            <Typography
              variant="h5"
              align="right"
              onClick={handleClickOpenPropiedadesCerrar}
              className={classes.mousePointer}
            >
              X
            </Typography>

            <TblPropiedades />
          </div>
        </Fade>
      </Modal>
      {/* Acreditacion*/}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={OpenModalAcreditacion}
        onClose={handleClickOpenAcreditacion}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={OpenModalAcreditacion}>
          <div className={classes.paper}>
            <Typography
              variant="h5"
              align="right"
              onClick={handleClickOpenAcreditacion}
              className={classes.mousePointer}
            >
              X
            </Typography>
            <TblAcreditacion />
            <Divider />
            <TblOrdenesnoPago />
          </div>
        </Fade>
      </Modal>

      {/** Sociedades */}

      <Dialog
        fullWidth="lg"
        maxWidth="lg"
        open={OpenModalSociedades}
        // onClose={handleClickPdf}
        aria-label="customized-dialog-title"
      >
        <DialogTitle>
          Detalle Socios y Sociedades
          <Button
            autoFocus
            onClick={hanleClickOpenSociedadesCerrar}
            color="primary"
            style={{ float: "right" }}
          >
            Cerrar
          </Button>
        </DialogTitle>
        <DialogContent dividers>
          <TblSociedades />
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={hanleClickOpenSociedadesCerrar}
            color="primary"
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
      {/*
     



      {/** Protesto */}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={OpenMOdalProtestos}
        onClose={hanleClickOpenProtesto}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 1000,
        }}
      >
        <Fade in={OpenMOdalProtestos}>
          <div className={classes.paper}>
            <Typography
              variant="h5"
              align="right"
              onClick={hanleClickOpenProtesto}
              className={classes.mousePointer}
            >
              X
            </Typography>

            <TblProtestos />
          </div>
        </Fade>
      </Modal>

      {/** MOrosidad */}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={OpenMOdalMorosidad}
        onClose={hanleClickOpenMorosidad}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 1000,
        }}
      >
        <Fade in={OpenMOdalMorosidad}>
          <div className={classes.paper}>
            <Typography
              variant="h5"
              align="right"
              onClick={hanleClickOpenMorosidad}
              className={classes.mousePointer}
            >
              X
            </Typography>

            <TblMorosidad />
          </div>
        </Fade>
      </Modal>

      <br />

      <Grid component="main">
        <div className={classes.TituloIdentificacion}>
          INDICADORES COMPORTAMIENTO
        </div>

        <CardContent>
          <Grid container direction="row" spacing={2}>
            <Grid item xs={6} sm={6} md={6} lg={3} xl={3}>
              <Card>
                <div className={classes.fondoCardIndicadores}>
                  <HomeWorkOutlinedIcon className={classes.sizeIcono} /> <br />
                  Registra Propíedades
                  <CardContent>
                    <div align="center">
                      <Fab
                        aria-label="save"
                        className={
                          datoIC &&
                          datoIC.DetalleInformacionPositiva
                            ?.BienesRaicesNumeroPropiedades > 0
                            ? classes.buttonSuccess
                            : classes.buttonGray
                        }
                        align="center"
                        size="small"
                      >
                        <Typography variant="h6" align="center">
                          {datoIC &&
                          datoIC.DetalleInformacionPositiva
                            ?.BienesRaicesNumeroPropiedades > 0
                            ? "SI"
                            : "NO"}
                        </Typography>
                      </Fab>
                    </div>
                  </CardContent>
                  <hr />
                  <TableContainer>
                    <Table>
                      {datoIC &&
                      datoIC.DetalleInformacionPositiva
                        ?.BienesRaicesNumeroPropiedades > 0 ? (
                        <TableBody>
                          <TableRow>
                            <TableCell style={{ width: "30%" }}>
                              N° Propiedades:
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ width: "70%" }}>
                              <strong>
                                {" "}
                                {datoIC &&
                                  datoIC.DetalleInformacionPositiva
                                    ?.BienesRaicesNumeroPropiedades}
                              </strong>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ width: "30%" }}>
                              Total Avalúo:
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ width: "70%" }}>
                              <strong>
                                {datoIC &&
                                  datoIC.DetalleInformacionPositiva
                                    ?.BienesRaicesAvaluoFiscal}
                              </strong>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ) : (
                        ""
                      )}
                    </Table>
                  </TableContainer>
                  <br />
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.buttonVermas}
                    onClick={handleClickOpenPropiedades}
                    disabled={
                      datoIC &&
                      datoIC.DetalleInformacionPositiva
                        ?.BienesRaicesNumeroPropiedades > 0
                        ? false
                        : true
                    }
                  >
                    Ver información{" "}
                  </Button>
                </div>
              </Card>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={3} xl={3}>
              <Card>
                <div className={classes.fondoCardIndicadores}>
                  {" "}
                  <CommuteOutlinedIcon className={classes.sizeIcono} /> <br />
                  Registra Vehículo
                  <CardContent>
                    <div align="center">
                      <Fab
                        aria-label="save"
                        className={
                          datoIC &&
                          datoIC.DetalleInformacionPositiva?.PoseeVehiculos
                            ? classes.buttonSuccess
                            : classes.buttonGray
                        }
                        align="center"
                        size="small"
                      >
                        <Typography variant="h6" align="center">
                          {datoIC &&
                          datoIC.DetalleInformacionPositiva?.PoseeVehiculos
                            ? "SI"
                            : "NO"}
                        </Typography>
                      </Fab>
                    </div>
                  </CardContent>
                  <hr />
                  {datoIC &&
                  datoIC.DetalleInformacionPositiva?.PoseeVehiculos ? (
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell>Total de Vehículos:</TableCell>
                            <TableCell>
                              <strong>
                                {datoIC &&
                                  datoIC.DetalleInformacionPositiva
                                    ?.NumeroVehiculos}
                              </strong>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    ""
                  )}
                  <br />
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.buttonVermas}
                    onClick={handleClickVehiculo}
                    disabled={
                      datoIC &&
                      datoIC.DetalleInformacionPositiva?.PoseeVehiculos
                        ? false
                        : true
                    }
                  >
                    Ver información
                  </Button>
                </div>
              </Card>
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={3} xl={3}>
              {datoIC &&
              datoIC.DetalleInformacionPositiva?.MovimientosDeBancos ==
                "0:-" ? (
                <Card>
                  <div className={classes.fondoCardIndicadores}>
                    <CardTravelOutlinedIcon className={classes.sizeIcono} />
                    <br />
                    Acreditación
                    <CardContent>
                      <div align="center">
                        <Fab
                          aria-label="save"
                          className={
                            datoIC &&
                            datoIC.DetalleInformacionPositiva
                              ?.MovimientosDeBancos == "0:-"
                              ? classes.ButtonDanger
                              : classes.buttonSuccess
                          }
                          align="center"
                          size="small"
                        >
                          <Tooltip title="Ver más información">
                            <Typography variant="h6" align="center">
                              {datoIC &&
                              datoIC.DetalleInformacionPositiva
                                ?.MovimientosDeBancos == "0:-"
                                ? "NO"
                                : "SI"}
                            </Typography>
                          </Tooltip>
                        </Fab>
                      </div>
                    </CardContent>
                    <hr />
                    <br />
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.buttonVermas}
                      onClick={handleClickOpenAcreditacion}
                      disabled={
                        datoIC &&
                        datoIC.DetalleInformacionPositiva
                          ?.MovimientosDeBancos == "0:-"
                          ? true
                          : false
                      }
                    >
                      Ver información
                    </Button>
                  </div>
                </Card>
              ) : (
                <Card>
                  <div className={classes.fondoCardIndicadores}>
                    <CardTravelOutlinedIcon className={classes.sizeIcono} />{" "}
                    <br /> Acreditación
                    <CardContent>
                      <div align="center">
                        <Fab
                          aria-label="save"
                          className={
                            datoIC &&
                            datoIC.DetalleInformacionPositiva
                              ?.MovimientosDeBancos != null
                              ? classes.buttonSuccess
                              : classes.ButtonDanger
                          }
                          align="center"
                          size="small"
                        >
                          <Tooltip title="Ver más información">
                            <Typography variant="h6" align="center">
                              {datoIC &&
                              datoIC.DetalleInformacionPositiva
                                ?.MovimientosDeBancos != null
                                ? "SI"
                                : "NO"}
                            </Typography>
                          </Tooltip>
                        </Fab>
                      </div>
                    </CardContent>
                    <hr />
                    {datoIC &&
                    datoIC.DetalleInformacionPositiva?.MovimientosDeBancos !=
                      null ? (
                      <TableContainer>
                        <Table>
                          <TableBody>
                            <TableRow>
                              <TableCell>Banco:</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <strong>{DatoBAnco}</strong>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ) : (
                      ""
                    )}
                    <br />
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.buttonVermas}
                      onClick={handleClickOpenAcreditacion}
                      disabled={
                        datoIC &&
                        datoIC.DetalleInformacionPositiva
                          ?.MovimientosDeBancos != null
                          ? false
                          : true
                      }
                    >
                      Ver información
                    </Button>
                  </div>
                </Card>
              )}
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={3} xl={3}>
              {datoIC &&
              datoIC.DetalleInformacionPositiva?.PublicacionesComoSociedad >
                0 ? (
                <Card>
                  <div className={classes.fondoCardIndicadores}>
                    <DomainOutlinedIcon className={classes.sizeIcono} />
                    <br />
                    Sociedades
                    <CardContent>
                      <div align="center">
                        <Fab
                          aria-label="save"
                          className={
                            datoIC &&
                            datoIC.DetalleInformacionPositiva
                              ?.PublicacionesComoSociedad > 0
                              ? classes.buttonSuccess
                              : classes.ButtonDanger
                          }
                          align="center"
                          size="small"
                        >
                          <Typography variant="h6" align="inherit">
                            {datoIC &&
                            datoIC.DetalleInformacionPositiva
                              ?.PublicacionesComoSociedad > 0
                              ? "SI"
                              : "NO"}{" "}
                          </Typography>
                        </Fab>
                      </div>
                    </CardContent>
                    <hr />
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell>Sociedades:</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              {" "}
                              {datoIC &&
                              datoIC.DetalleInformacionPositiva
                                ?.PublicacionesComoSociedad > 0 ? (
                                <strong>
                                  {datoIC &&
                                    datoIC.DetalleInformacionPositiva
                                      ?.PublicacionesComoSociedad}
                                </strong>
                              ) : (
                                "0"
                              )}
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>Socios:</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              {datoIC &&
                              datoIC.DetalleInformacionPositiva
                                ?.PublicacionesComoSocio > 0 ? (
                                <strong>
                                  {datoIC &&
                                    datoIC.DetalleInformacionPositiva
                                      ?.PublicacionesComoSocio}
                                </strong>
                              ) : (
                                "0"
                              )}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <br />
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.buttonVermas}
                      onClick={hanleClickOpenSociedades}
                      disabled={
                        datoIC &&
                        datoIC.DetalleInformacionPositiva
                          ?.PublicacionesComoSociedad > 0
                          ? false
                          : true
                      }
                    >
                      Ver información{" "}
                    </Button>
                  </div>
                </Card>
              ) : (
                <Card>
                  <div className={classes.fondoCardIndicadores}>
                    <DomainOutlinedIcon className={classes.sizeIcono} />
                    <br />
                    Sociedades
                    <CardContent>
                      <div align="center">
                        <Fab
                          aria-label="save"
                          className={
                            datoIC &&
                            datoIC.DetalleInformacionPositiva
                              ?.PublicacionesComoSocio > 0
                              ? classes.buttonSuccess
                              : classes.ButtonDanger
                          }
                          align="center"
                          size="small"
                        >
                          <Typography variant="h6" align="inherit">
                            {datoIC &&
                            datoIC.DetalleInformacionPositiva
                              ?.PublicacionesComoSocio > 0
                              ? "SI"
                              : "NO"}{" "}
                          </Typography>
                        </Fab>
                      </div>
                    </CardContent>
                    <hr />
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell>Sociedades: </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              {datoIC &&
                              datoIC.DetalleInformacionPositiva
                                ?.PublicacionesComoSociedad > 0 ? (
                                <strong>
                                  {datoIC &&
                                    datoIC.DetalleInformacionPositiva
                                      ?.PublicacionesComoSociedad}
                                </strong>
                              ) : (
                                "0"
                              )}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Socios: </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              {datoIC &&
                              datoIC.DetalleInformacionPositiva
                                ?.PublicacionesComoSocio > 0 ? (
                                <strong>
                                  {datoIC &&
                                    datoIC.DetalleInformacionPositiva
                                      ?.PublicacionesComoSocio}
                                </strong>
                              ) : (
                                "0"
                              )}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <br />
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.buttonVermas}
                      onClick={hanleClickOpenSociedades}
                      disabled={
                        datoIC &&
                        datoIC.DetalleInformacionPositiva
                          ?.PublicacionesComoSocio > 0
                          ? false
                          : true
                      }
                    >
                      Ver información{" "}
                    </Button>
                  </div>
                </Card>
              )}
            </Grid>
          </Grid>

          <Grid container direction="row" spacing={2}>
            <Grid item xs={6} sm={6} md={6} lg={3} xl={3}>
              <Card>
                <div className={classes.fondoCardIndicadores}>
                  {" "}
                  <TrendingDownOutlinedIcon className={classes.sizeIcono} />
                  <br />
                  Registro de Quiebra
                  <CardContent>
                    <div align="center">
                      <Fab
                        aria-label="save"
                        className={
                          datoIC && datoIC.SemaforoInformacion?.RegistroQuiebras
                            ? classes.ButtonDanger
                            : classes.buttonSuccess
                        }
                        align="left"
                        size="small"
                      >
                        <Tooltip title="Ver más información">
                          <Typography variant="h6" align="center">
                            {datoIC &&
                            datoIC.SemaforoInformacion?.RegistroQuiebras
                              ? "SI"
                              : "NO"}
                          </Typography>
                        </Tooltip>
                      </Fab>
                    </div>
                  </CardContent>
                  <br />
                  {/*<Button variant="contained" color="primary" className={classes.buttonVermas} disabled={datoIC && datoIC.SemaforoInformacion?.RegistroQuiebras ? false : true}  >Ver información</Button>*/}
                </div>
              </Card>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={3} xl={3}>
              <Card>
                <div className={classes.fondoCardIndicadores}>
                  <BallotOutlinedIcon className={classes.sizeIcono} /> <br />
                  Registro de Protestos
                  <CardContent>
                    <div align="center">
                      <Fab
                        aria-label="save"
                        className={
                          datoIC &&
                          datoIC.Resumenes?.ProtestosVigentes?.TotalDocumentos >
                            0
                            ? classes.ButtonDanger
                            : datoIC.Resumenes?.ProtestosVigentesSinacofi
                                ?.TotalDocumentos > 0
                            ? classes.ButtonDanger
                            : classes.buttonSuccess
                        }
                        align="center"
                        size="small"
                      >
                        <Typography variant="h6" align="center">
                          {datoIC &&
                          datoIC.Resumenes?.ProtestosVigentes?.TotalDocumentos >
                            0
                            ? "SI"
                            : datoIC.Resumenes?.ProtestosVigentesSinacofi
                                ?.TotalDocumentos > 0
                            ? "SI"
                            : "NO"}
                        </Typography>
                      </Fab>
                    </div>
                  </CardContent>
                  <hr />
                  {datoIC &&
                  datoIC.Resumenes?.ProtestosVigentes?.TotalDocumentos > 0 &&
                  datoIC.Resumenes?.ProtestosVigentesSinacofi.TotalDocumentos >
                    0 ? (
                    ""
                  ) : datoIC.Resumenes?.ProtestosVigentes?.TotalDocumentos >
                    0 ? (
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell>
                              Total de Protesto:{" "}
                              <strong>
                                {datoIC &&
                                  datoIC.Resumenes?.ProtestosVigentes
                                    ?.TotalDocumentos}
                              </strong>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : datoIC.Resumenes?.ProtestosVigentesSinacofi
                      .TotalDocumentos > 0 ? (
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell>
                              Total de Protesto:{" "}
                              <strong>
                                {datoIC &&
                                  datoIC.Resumenes?.ProtestosVigentesSinacofi
                                    ?.TotalDocumentos}
                              </strong>{" "}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    ""
                  )}
                  <Grid>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.buttonVermas}
                      onClick={hanleClickOpenProtesto}
                      disabled={
                        datoIC &&
                        datoIC.Resumenes?.ProtestosVigentes?.TotalDocumentos > 0
                          ? false
                          : datoIC.Resumenes?.ProtestosVigentesSinacofi
                              .TotalDocumentos > 0
                          ? false
                          : true
                      }
                    >
                      Ver información
                    </Button>
                  </Grid>
                </div>
              </Card>
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={3} xl={3}>
              <Card>
                <div className={classes.fondoCardIndicadores}>
                  <ImportContactsOutlinedIcon className={classes.sizeIcono} />
                  <br />
                  Boletín Laboral
                  <CardContent>
                    <div align="center">
                      <Fab
                        aria-label="save"
                        className={
                          datoIC &&
                          datoIC.Resumenes?.BoletinLaboral?.TotalDocumentos > 0
                            ? classes.ButtonDanger
                            : classes.buttonSuccess
                        }
                        align="center"
                        size="small"
                      >
                        <Typography variant="h6" align="center">
                          {datoIC &&
                          datoIC.Resumenes?.BoletinLaboral?.TotalDocumentos > 0
                            ? "SI"
                            : "NO"}
                        </Typography>
                      </Fab>
                    </div>
                  </CardContent>
                  <hr />
                  {datoIC &&
                  datoIC.Resumenes?.BoletinLaboral?.TotalDocumentos > 0 ? (
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell>Total Boletin laboral:</TableCell>
                            <TableCell>
                              <strong>
                                {datoIC &&
                                  datoIC.Resumenes?.BoletinLaboral
                                    ?.TotalDocumentos}
                              </strong>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    ""
                  )}
                  <br />
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.buttonVermas}
                    onClick={handleClickBoletin}
                    disabled={
                      datoIC &&
                      datoIC.Resumenes?.BoletinLaboral?.TotalDocumentos > 0
                        ? false
                        : true
                    }
                  >
                    Ver información
                  </Button>
                </div>
              </Card>
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={3} xl={3}>
              <Card>
                <div className={classes.fondoCardIndicadores}>
                  <AccountBalanceWalletOutlinedIcon
                    className={classes.sizeIcono}
                  />{" "}
                  <br /> Registra Morosidad
                  <CardContent>
                    <div align="center">
                      <Fab
                        aria-label="save"
                        className={
                          datoIC &&
                          datoIC.Resumenes?.MorosidadConsolidada
                            ?.TotalDocumentos > 0
                            ? classes.ButtonDanger
                            : datoIC.Resumenes?.MorosidadConsolidadaSinacofi
                                ?.TotalDocumentos > 0
                            ? classes.ButtonDanger
                            : classes.buttonSuccess
                        }
                        align="center"
                        size="small"
                      >
                        <Typography variant="h6" align="center">
                          {datoIC &&
                          datoIC.Resumenes?.MorosidadConsolidada
                            ?.TotalDocumentos > 0
                            ? "SI"
                            : datoIC.Resumenes?.MorosidadConsolidadaSinacofi
                                ?.TotalDocumentos > 0
                            ? "SI"
                            : "NO"}
                        </Typography>
                      </Fab>
                    </div>
                  </CardContent>
                  <hr />
                  {datoIC &&
                  datoIC.Resumenes?.MorosidadConsolidada?.TotalDocumentos > 0 &&
                  datoIC.Resumenes?.MorosidadConsolidadaSinacofi
                    ?.TotalDocumentos > 0 ? (
                    " "
                  ) : datoIC.Resumenes?.MorosidadConsolidada?.TotalDocumentos >
                    0 ? (
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell>
                              Cant. Morosidades:{" "}
                              <strong>
                                {datoIC &&
                                  datoIC.Resumenes?.MorosidadConsolidada
                                    ?.TotalDocumentos}
                              </strong>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : datoIC.Resumenes?.MorosidadConsolidadaSinacofi
                      ?.TotalDocumentos > 0 ? (
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell>
                              Cant. Morosidades:{" "}
                              <strong>
                                {datoIC &&
                                  datoIC.Resumenes?.MorosidadConsolidadaSinacofi
                                    ?.TotalDocumentos}
                              </strong>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    " "
                  )}
                  <br />
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.buttonVermas}
                    onClick={hanleClickOpenMorosidad}
                    disabled={
                      (datoIC &&
                        datoIC.Resumenes?.MorosidadConsolidada
                          ?.TotalDocumentos > 0) ||
                      datoIC.Resumenes?.MorosidadConsolidadaSinacofi
                        ?.TotalDocumentos > 0
                        ? false
                        : true
                    }
                  >
                    Ver información
                  </Button>
                </div>
              </Card>
            </Grid>
          </Grid>
        </CardContent>
      </Grid>
    </div>
  );
};

export default IndicadoresPositivoNegativo;
